/**
 * Handle access strategy system
 */
export enum AccessStrategy {
  UNKNOWN = 0,
  AMBIGOUS = 1,
  WHITE_LIST = 2,
  BLACK_LIST = 3,
  CENTRALIZED_WHITE_LIST = 4,
  CENTRALIZED_BLACK_LIST = 5,
  NO_TAG = 6,
  NO_LIST = 7,
}

/**
 * Handle pos kind type
 */
export enum POSKind {
  CREDIT = 0,
  PREPAID = 1,
  NO_POS = 2,
}
//
/**
 * Handle access result response
 */
export enum AccessResult {
  ACCESS_RESET = -1, //Used for touch SIBO to reset access result
  ACCESS_DENIED = 0,
  ACCESS_ALLOWED = 40,
  CARD_OUT = 40,
  CARD_IN = 60,
  ACCESS_DENIED_EXPIRED_CARD = 200,
  ACCESS_DENIED_NOT_VALID_CARD = 201,
  ACCESS_DENIED_WRONG_TIMESLOT = 202,
  ACCESS_DENIED_WRONG_CALENDAR = 203,
  ACCESS_DENIED_LOCK_CARD = 204,
  ACCESS_DENIED_WRONG_PLANT_CODE = 205,
  UNDEFINED = 999,
  NO_DIRECTION = 998,
}

/**
 * Handle access control generic exception
 */
export enum AccessControlException {
  NONE = 0,
  ENVIRONMENT_WITHOUT_ACCESS_CONTROL_SYSTEM = 1,
  UPDATE_KEY_WITH_CARD_PROGRAMMER = 2,
  CUSTOMER_ROOM_LIMIT_REACHED = 3,
  STAFF_ROOM_ACCESS_LIMIT_REACHED = 4,
  SAFLOCK_ROOM_ACCESS_LIMIT_REACHED = 5,
  SAFLOCK_COMMON_AREA_LIMIT_REACHED = 6,
  SAFLOCK_ONLY_ROOM_AND_ACCESS_COMMON = 7,
  INCOMPATIBLE_ACCESS_CONTROL_SYSTEM = 8,
  ROOM_NOT_FOUND = 20,
  RESERVATION_NOT_FOUND = 21,

  CARD_IS_NOT_VALID = 100,
  CARD_STATE_NOT_VALID = 101,
  CARD_IS_NOT_TEMPLATE = 102,
  CARD_NOT_FOUND = 103,
  CARD_OPERATION_GENERIC_EXCEPTION = 104,
  CARD_MANUFACTURER_SYSTEM_NOT_ASSIGNED = 105,
  CARD_UNLOCK_GENERIC_EXCEPTION = 106,

  /**The selected Card's manifacturerSystem DOES NOT belong to the "AccessManufacturerSystemStateWritten" group;
   * this means that changing its code REQUIRES to write the card again.
   */
  CARD_CHANGE_CODE_NEED_REWRITE = 110,
  /**The selected Card's Kind is not 'Real Card' */
  CARD_CHANGE_CODE_ERROR_NOT_REAL_CARD = 111,
  /**The code entered is outside the range of admissible values */
  CARD_CHANGE_CODE_ERROR_OUT_OF_RANGE = 112,
  /**The code entered is already in use by another valid Card */
  CARD_CHANGE_CODE_ERROR_CARD_NUMBER_ALREADY_USED = 113,
  /**The code entered DOES NOT contain only the numbers 1-5 (this is required by the ManufacturerSystem 'Bluemotix 5')*/
  CARD_CHANGE_CODE_ERROR_BLUEMOTIX5 = 114,
  /**Generic error in the manual insertion of a new code */
  CARD_CHANGE_CODE_ERROR_GENERIC = 115,

  CARD_ENVIRONMENT_NOT_EXIST = 200,
  CARD_ENVIRONMENT_GENERIC_OPERATION_EXCEPTION = 201,

  CUSTOMER_STAFF_NOT_FOUND = 300,
  CUSTOMER_STAFF_SURNAME_NOT_VALUD = 301,
  CUSTOMER_STAFF_NOT_CREATED = 302,
  CUSTOMER_STAFF_MAIL_ALREADY_EXIST = 303,

  ENVIRONMENT_ID_NOT_VALID = 400,
  ENVIRONMENT_NOT_FOUND = 401,
  ENVIRONMENT_MANUFACTURER_SYSTEM_NOT_VALID = 402,

  CISA_CATEGORY_NOT_VALID = 500,
  CISA_ZONE_NOT_VALID = 501,
  CISA_ZONE_NOT_ALLOWED_ON_GUEST_CARD = 502,
}
